export default __webpack_public_path__ + "static/CareerFeatureFive-e5f8184cbffe95c82de1cfdbadb6786a.webp";